import { requests } from './request2'

//新增培训报名接口
export function addNewOrder(data) {
    return requests({
        url: '/addOrder',
        method: 'post',
        data
    })
}
//用户认证
export function authenticationUser(data) {
    return requests({
        url: '/auth/authenticationUser',
        method: 'post',
        data
    })
}
// 删除快递地址
export function delAddress(data) {
    return requests({
        url: '/userExpress/delAddress?addressId=' + data,
        method: 'get',
    })
}
// 删除发票抬头
export function delInvoice(data) {
    return requests({
        url: '/invoice/delInvoice?invoiceId=' + data,
        method: 'get',
    })
}
export function queryClassByProject(data) {
    return requests({
        url: '/queryClassByProject/' + data,
        method: 'post',
    })
}


